<template>
  <div class="order">
    <div class="" v-loading="loading">
      <!-- <div class="s_wrapper">
        <el-input class="s_input" v-model="orderNum" placeholder="请输入订单编号" suffix-icon="el-icon-search"
          @change="onSearch" clearable></el-input>
        <el-select class="s_input" v-model="orderStatus" placeholder="请输入订单状态" clearable @change="onSearch">
          <el-option v-for="item in orderStatusOptions" :key="item.value" :label="item.label"
            :value="item.value"></el-option>
        </el-select>
        <el-date-picker v-model="formInline.time" @change="gettime" type="daterange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期"
          style="border-radius: 10px;  margin-left: 20px; border: 1px solid #ccc" value-format="yyyy-MM-dd">
        </el-date-picker>
      </div> -->
      <div style="height: 60px;"></div>
      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="orderStatus" label="行为类型">
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == -1">观看</span>
              <span v-if="scope.row.orderStatus == 0">课后问答</span>
              <span v-if="scope.row.orderStatus == 1">邀请用户</span>
              <span v-if="scope.row.orderStatus == 2">每日打卡</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="orderStatus" label="场景">
            <template slot-scope="scope">
              <span v-if="scope.row.orderStatus == -1">直播</span>
              <span v-if="scope.row.orderStatus == 0">课程</span>
              <span v-if="scope.row.orderStatus == 1">全平台</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="" label="积分值"></el-table-column>
          <el-table-column label="操作" min-width="100" header-align="center" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" plain @click="handleRevise(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination> -->
    <!-- 修改 -->
    <el-dialog title="修改" :visible.sync="dialogVisible" width="30%" @close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="积分值" prop="pickupCode">
          <el-input v-model="ruleForm.pickupCode" placeholder="请输入积分"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,//确认收货
      orderNum: "",//订单编号
      orderStatus: "",//订单状态
      tableData: [],
      // currentPage: 1, // 当前页码
      // pageSize: 10, // 每页显示的行数
      // pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      // totalCount: 0, // 总记录数（需要从后端获取）
      startTime: '',//开始时间
      endTime: '',//结束时间
      formInline: {
        time: []
      },//日期区间,
      //修改积分
      ruleForm: {
        pickupCode: '',
      },
      rules: {
        pickupCode: [
          { required: true, message: '请输入积分', trigger: 'blur' },
        ],
      },
    }
  },
  created() {
    // this.getRequestList()
  },
  methods: {
    getRequestList() {
      this.loading = true
      this.$axios
        .get(this.$api.orderList, {
          params: {
            orderStatus: this.orderStatus || null, // 订单状态：-1已取消；0待付款 ；1已支付；2已退款
            orderNum: this.orderNum || null,
            startTime: this.startTime || null,//开始时间
            endTime: this.endTime || null,//结束时间
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        .then(res => {
          this.tableData = res.result.list
          this.totalCount = res.result.totalCount
          this.loading = false
        })
        .catch(err => {
          this.$message.error(err.desc)
          this.loading = false
        })
    },
    // 时间区间搜索
    gettime() {
      this.startTime = this.formInline.time ? this.formInline.time[0] || "" : "";
      this.endTime = this.formInline.time ? this.formInline.time[1] || "" : "";
      this.getRequestList()
    },
    // 修改积分
    handleRevise(row) {
      console.log(row);
      // this.dialogVisible = true
      alert('暂未开放')
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },
    // 自提确认收货
    handleSubmitForm() {
      const { pickupCode } = this.ruleForm
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$api.confirmOrder,
            { pickupCode }
          ).then((res) => {
            const { code } = res
            if (code == 100) {
              this.$message({ message: '恭喜你，自提收货成功!', type: 'success' });
              this.dialogVisible = false
              this.onSearch()
            }
          }).catch((err) => {
            console.log(err);
            this.$message.error(err.desc)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置
    resetForm() {
      this.ruleForm = {}
      this.$refs.ruleForm.resetFields();
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getRequestList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getRequestList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getRequestList()
    },
  },
}
</script>

<style scoped lang="scss">
.order {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
